import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai';
import UpdownArrow from '../../assets/images/updown-arrow.png'

import DataTable from "../../components/Datatable/DataTable";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import StringInput from "../../components/Input/StringInput/StringInput";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Button from "../../components/Button/Button";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import Excel from "../../../src/assets/images/excel.svg";
import { numFormat } from "../../hoc/Shared/utility";

class OngoingListing extends Component {
    /* ============ component lifecycle [START] ============ */
    constructor(props) {
        super(props);
        this.state =
        {
            showCard: false,
        };
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    noFormatter = (cell, row, rowIndex) => {
        let rowNumber =
            (this.props.totalRecords - rowIndex - ((this.props.activePage - 1) * this.props.limit))
        return <span>{rowNumber}</span>;
    };

    toggleCard = () => {
        this.setState({
            showCard: !this.state.showCard
        })
    }
    /* ============ function [END] ============ */

    render() {
        const { t } = this.props;
        let permission = this.props.permission ? this.props.permission : [];
        let rsListing = [];
        let stCls = {
            0: "primary",
            1: "success",
            2: "danger",
            3: "secondary",
            4: "danger",
        };
        // let permission = this.props.currentUser.permission
        //     ? this.props.currentUser.permission
        //     : [];

        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            { text: t("transaction.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("transaction.order-id"), dataField: "order_id", sort: true, onSort: this.props.onSort, headerStyle: { width: "115px" } },
            { text: t("transaction.member"), dataField: "username", sort: true, onSort: this.props.onSort },
            { text: t('member.name'), dataField: "name", sort: true, onSort: this.props.onSort },
            { text: t("transaction.transaction-type"), dataField: "transaction_type", sort: true, onSort: this.props.onSort },
            { text: t("transaction.transaction-channel"), dataField: "transaction_channel", sort: true, onSort: this.props.onSort }, 
            { text: t('transaction.bank-details'), dataField: 'bank_name', sort: true, onSort: this.props.onSort },
            { text: t("transaction.debit"), dataField: "debit", sort: true, onSort: this.props.onSort, headerStyle: { width: "120px" } },
            { text: t("transaction.credit"), dataField: "credit", sort: true, onSort: this.props.onSort, headerStyle: { width: "120px" } },
            { text: t('transaction.fees'), dataField: "fees", sort: true, onSort: this.props.onSort, headerStyle: { width: '120px' } },
            { text: t("member.monitor-status"), dataField: "monitorStatus", sort: true, onSort: this.props.onSort },
            { text: t("member.autowithdrawal-status"), dataField: "autowithdrawal_status", sort: false },
            { text: t('transaction.country'), dataField: "country", sort: false },
            { text: t("transaction.status"), dataField: "status", sort: true, onSort: this.props.onSort, headerStyle: { width: "96px" } },
            { text: t('transaction.create-date'), dataField: "create_date", sort: true, onSort: this.props.onSort },
            { text: t("transaction.update-by"), dataField: "update_by", sort: true, onSort: this.props.onSort },
            { text: t("global.action"), dataField: "action", hidden: permission.includes("deposit_approve") ? false : true }
        ];

        if (this.props.data) {
            rsListing = this.props.data.map((val, idx) => {
                let stVal = "";
                let orderIdVal = "";
                let usernameVal = "";
                let bankDetails = "";
                let bankDetailsStr = '-';
                let transaction_type = "";
                const isDeposit = val.transaction_type === 'deposit';
                const isWithdrawal = val.transaction_type === 'withdrawal';
                const isMallReward = val.transaction_type === 'mall-reward-bonus';
                const canApproveDeposit = permission.includes("deposit_approve");
                const canAccessDepositDetails = permission.includes("deposit_details_access");
                const canAccessWithdrawalDetails = permission.includes("withdrawal_details_access");
                const isPendingOrProcessing = val.status === 0 || val.status === 3;
                const isBankTransfer = val.transaction_channel === 'bank-transfer';
                const isQuickPay = val.transaction_channel === "quick-pay";
                const isCrypto = val.transaction_channel === "crypto";
                const isEWallet = val.transaction_channel === "e-wallet";
                const isShowApproveButton = isDeposit && isPendingOrProcessing && canApproveDeposit && (isBankTransfer || isQuickPay || isCrypto || isEWallet);

                if (val.promotion_title) {
                    transaction_type = <div> {t(`transaction-type.${val.transaction_type}`)} <br/> {'('+val.promotion_title+')'}</div>;
                }
                else {
                    transaction_type = t(`transaction-type.${val.transaction_type}`);
                }

                const num_format = numFormat(val.currency);

                if (val.bank_name) {
                    if (val.transaction_type === 'deposit') {
                        bankDetailsStr = `${val.swift_code_deposit}: ${val.bank_acc_name}`;
                    } else {
                        bankDetailsStr = `${val.swift_code_withdrawal}: ${val.bank_acc_name}`;
                    }
                }

                if (val.transaction_channel === 'quick-pay' || val.transaction_channel === 'e-wallet') {
                    bankDetailsStr = val.payment_type;
                }

                stVal = (
                    <span
                        className={`badge-${stCls[val.status]
                            }`}
                    >
                        {t(`transaction.status-desc.${val.status}`)}
                    </span>
                );

                // control what's shown in Order ID column
                // determines whether it's clickable or not
                if (isDeposit && canAccessDepositDetails) {
                    orderIdVal = <b>
                        <a
                            href="/#"
                            onClick={(event) =>
                                this.props.editHandler(event, val.id, val.transaction_type)
                            }
                        >
                            {val.order_id}
                            <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                        </a>
                    </b>
                } else if (isWithdrawal && canAccessWithdrawalDetails) {
                    orderIdVal = <b>
                        <a
                            href="/#"
                            onClick={(event) =>
                                this.props.editHandler(event, val.id, val.transaction_type)
                            }
                        >
                            {val.order_id}
                            <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                        </a>
                    </b>
                } 
                else if (isMallReward) {
                    orderIdVal = <b>
                        <a
                            href="/#"
                            onClick={(event) =>
                                this.props.editHandler(event, val.coin_transaction_id, val.transaction_type)
                            }
                        >
                            {val.order_id}
                            <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                        </a>
                    </b>
                } else {
                    orderIdVal = val.order_id;
                }


                usernameVal = this.props.permission.includes("member_view") ? (
                    <b><a href="/#" onClick={event => this.props.redirectHandler(event, val.member_id, val.username)}>
                        {val.username}
                    </a></b>
                ) : (val.username);

                bankDetails = bankDetailsStr?.length > 15 ? bankDetailsStr.substring(0, 15) + "..." : bankDetailsStr;

                let actionVal = isShowApproveButton ? (
                        <div className="btn-group">
                            {canApproveDeposit && (
                                <a
                                    href="/#"
                                    onClick={(event) =>
                                        this.props.depositApproveHandler(
                                            event,
                                            val.id,
                                            val.credit,
                                            val.fees,
                                            val.bank_balance,
                                            val.transaction_channel,
                                            val.country_id
                                        )
                                    }
                                    className="btn btn-md success-btn"
                                    data-toggle="tooltip"
                                    title="approve"
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </a>
                            )}
                        </div>
                ) : ''; // the empty string is necessary or column will display 'false'

                return {
                    no: idx,
                    order_id: orderIdVal,
                    username: usernameVal,
                    name: val.name,
                    transaction_type: transaction_type,
                    transaction_channel: val.transaction_channel
                        ? t(`transaction-channel.${val.transaction_channel}`)
                        : "-",
                    bank_name: (val.payment_type === "SecretPayBankOffline" && val.status === 1 && val.bank_name) ? val.bank_name.substring(0, 15) + "..."  : bankDetails,
                    status: stVal,
                    approve_date: (val.approve_date || '-'),
                    create_date: val.create_date,
                    update_by: val.update_by,
                    debit: new Intl.NumberFormat("en-US", num_format).format(val.debit),
                    credit: new Intl.NumberFormat("en-US", num_format).format(val.credit),
                    fees: new Intl.NumberFormat('en-US', num_format).format(val.fees),
                    monitorStatus: val.monitor_status,
                    autowithdrawal_status: val.autowithdrawal_status,

                    country: t(`global.country_shortcode.${val.shortcode}`),
                    action: actionVal,
                };
            });
        }
        /* ======================== datatables data assign [END] ======================== */

        return (
            <Auxiliary>
                <div className="breadcrumb-header justify-content-between">
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">
                                {t("ongoing.title")}
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-xl-12">
                        <div className="card card-body">
                            <div className="col mt-auto">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                                    <div
                                        className={`form-horizontal filter-function row
                            ${this.state.showCard ? 'open' : 'close'} filter-wrapper-1`}>
                                        {/* <div className="col-6"> */}
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.create-date")}
                                                </label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="fas fa-calendar-check" />
                                                    </span>
                                                    <DateTimePicker
                                                        id="transaction_date"
                                                        name="transaction_date"
                                                        className="form-control filter-input"
                                                        range={true}
                                                        timePicker={true}
                                                        // format="YYYY/MM/DD"
                                                        value={
                                                            this.props.filter
                                                                .transaction_date
                                                        }
                                                        onChange={
                                                            this.props.onInputChange
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.member")}
                                                </label>
                                                <StringInput
                                                    id="username"
                                                    name="username"
                                                    value={this.props.filter.username}
                                                    onChange={this.props.onInputChange}
                                                    className="filter-input"
                                                    onSearchPress={(evt) =>
                                                        evt.key === "Enter" &&
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.order-id")}
                                                </label>
                                                <StringInput
                                                    id="order_id"
                                                    name="order_id"
                                                    value={this.props.filter.order_id}
                                                    onChange={this.props.onInputChange}
                                                    className="filter-input"
                                                    onSearchPress={(evt) =>
                                                        evt.key === "Enter" &&
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.status")}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="status"
                                                        name="status"
                                                        onChange={this.props.onInputChange}
                                                        value={this.props.filter.status}
                                                    >
                                                        <option value=""></option>
                                                        {this.props.ddStatus &&
                                                            this.props.ddStatus.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option
                                                                            key={val.id}
                                                                            value={val.id}
                                                                        >
                                                                            {t(`transaction.status-desc.${val.id}`)}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.transaction-type")}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="transaction_type"
                                                        name="transaction_type"
                                                        onChange={this.props.onInputChange}
                                                        value={
                                                            this.props.filter
                                                                .transaction_type
                                                        }
                                                    >
                                                        <option value=""></option>
                                                        {this.props.ddTransactionType &&
                                                            this.props.ddTransactionType.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option
                                                                            key={val.id}
                                                                            value={val.id}
                                                                        >
                                                                            {t(
                                                                                `transaction-type.${val.slug}`
                                                                            )}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t(
                                                        "transaction.transaction-channel"
                                                    )}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="transaction_channel"
                                                        name="transaction_channel"
                                                        onChange={this.props.onInputChange}
                                                        value={
                                                            this.props.filter
                                                                .transaction_channel
                                                        }
                                                    >
                                                        <option value=""></option>
                                                        {this.props.ddTransactionChannel &&
                                                            this.props.ddTransactionChannel.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option
                                                                            key={val.id}
                                                                            value={val.id}
                                                                        >
                                                                            {t(
                                                                                `transaction-channel.${val.slug}`
                                                                            )}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.debit")}
                                                </label>
                                                <div className="input-group">
                                                    <NumberInput
                                                        id="min_debit"
                                                        name="min_debit"
                                                        value={this.props.filter.min_debit}
                                                        onChange={this.props.onInputChange}
                                                        placeholder={t("transaction.min")}
                                                        className="filter-input"
                                                        onKeyPress={(evt) =>
                                                            (evt.key === "e" &&
                                                                evt.preventDefault()) ||
                                                            (evt.key === "Enter" &&
                                                                this.props.refreshHandler())
                                                        }
                                                    />{" "}
                                                    <span style={{ margin: "auto 5px" }}>
                                                        {" "}
                                                        -{" "}
                                                    </span>
                                                    <NumberInput
                                                        id="max_debit"
                                                        name="max_debit"
                                                        value={this.props.filter.max_debit}
                                                        onChange={this.props.onInputChange}
                                                        placeholder={t("transaction.max")}
                                                        className="filter-input"
                                                        onKeyPress={(evt) =>
                                                            (evt.key === "e" &&
                                                                evt.preventDefault()) ||
                                                            (evt.key === "Enter" &&
                                                                this.props.refreshHandler())
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.credit")}
                                                </label>
                                                <div className="input-group">
                                                    <NumberInput
                                                        id="min_credit"
                                                        name="min_credit"
                                                        value={this.props.filter.min_credit}
                                                        onChange={this.props.onInputChange}
                                                        placeholder={t("transaction.min")}
                                                        className="filter-input"
                                                        onKeyPress={(evt) =>
                                                            (evt.key === "e" &&
                                                                evt.preventDefault()) ||
                                                            (evt.key === "Enter" &&
                                                                this.props.refreshHandler())
                                                        }
                                                    />{" "}
                                                    <span style={{ margin: "auto 5px" }}>
                                                        {" "}
                                                        -{" "}
                                                    </span>
                                                    <NumberInput
                                                        id="max_credit"
                                                        name="max_credit"
                                                        value={this.props.filter.max_credit}
                                                        onChange={this.props.onInputChange}
                                                        placeholder={t("transaction.max")}
                                                        className="filter-input"
                                                        onKeyPress={(evt) =>
                                                            (evt.key === "e" &&
                                                                evt.preventDefault()) ||
                                                            (evt.key === "Enter" &&
                                                                this.props.refreshHandler())
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div className="form-group">
                                                <label className="font-weight-bolder">
                                                    {t("transaction.country")}
                                                </label>
                                                <div className="select-input">
                                                    <select
                                                        className="form-control filter-input"
                                                        id="country"
                                                        name="country"
                                                        onChange={this.props.onInputChange}
                                                        value={this.props.filter.country}
                                                    >
                                                        <option value=""></option>
                                                        <option value="all">{t('global.all')}</option>
                                                        {this.props.ddCountry &&
                                                            this.props.ddCountry.map(
                                                                (val, idx) => {
                                                                    return (
                                                                        <option key={val.id} value={val.id}>
                                                                            {t(`global.country_shortcode.${val.shortcode}`)}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                    </select>
                                                    <img className="updown-icon" src={UpdownArrow} alt="Up Down Arrow" />
                                                </div>

                                            </div>
                                        </div>
                                        {/* </div> */}


                                        <div className="col mt-auto">
                                            <div className="d-flex">
                                                <Button
                                                    typeButton="button"
                                                    classValue="btn btn-blue"
                                                    idValue="filter"
                                                    buttonName={t("global.filter")}
                                                    clicked={() =>
                                                        this.props.refreshHandler()
                                                    }
                                                />
                                                &nbsp;
                                                <Button
                                                    typeButton="button"
                                                    classValue="btn btn-secondary"
                                                    idValue="reset"
                                                    buttonName={t("global.reset")}
                                                    clicked={() =>
                                                        this.props.clearHandler()
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="show-btn"
                                onClick={() => this.toggleCard()}>
                                {
                                    this.state.showCard ? <AiFillMinusCircle /> : <AiFillPlusCircle />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header pb-0">
                                <div className="d-flex justify-content-between">
                                    <h4 className="card-title mg-b-0">
                                        {t("ongoing.listing")}
                                    </h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={rsListing}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "activePage"
                                            )
                                        }
                                        sizePerPageHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "limit"
                                            )
                                        }
                                        searchChangeHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "searchValue"
                                            )
                                        }
                                        searchValue={this.props.searchValue}
                                        hideSearchBar={true}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(OngoingListing);
